<div class="grid" *ngIf="invalidKeypads !== 0">
	<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 py-1 border-round-xl">
		<i class="pi cm-alert text-2xl text-yellow-700 mx-2"></i>
		<p-tag [value]="'KEYPADS_INVALID'|translate:{invalidKeypads: invalidKeypads} " severity="warning"></p-tag>
	</div>
</div>
<div class="grid">
	<div [class]="actionLayout('left')">
		<p-button id="addMtmaKeypad" label="{{ 'ADD_KEYPAD' | translate }}" (click)="addKeypad()" icon="pi cm-plus"
			[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
		</p-button>
	</div>
	<div [class]="actionLayout('center')">
		<div class="flex flex-column justify-content-center gap-2">
			<span class="flex align-items-center justify-content-center font-semibold">
				<i class="pi cm-memory-storage mr-1"></i>
				{{'MEMORY_USAGE' | translate }}: {{memorySize}} / {{maxMemorySize}}
			</span>
			<p-progressBar [value]="getValueMemory()" styleClass="surface-900">
				<ng-template pTemplate="content" let-value>
					<span *ngIf="getValueMemory() > 4">{{getValueMemory()}} %</span>
				</ng-template>
			</p-progressBar>
		</div>
	</div>
	<div [class]="actionLayout('right')">
		<span class="p-input-icon-left" [class]="dynamicInputSearchWidth()">
			<i class="pi cm-search"></i>
			<input [formControl]="searchFilter" pInputText type="text" id="mtma-keypad-input-search" class="surface-900"
				placeholder="{{ 'SEARCH' | translate }}" [ngClass]="dynamicInputSearchWidth()" maxlength="60" />
		</span>
	</div>
	<div class="col-12">
		<div class="card border-round">
			<p-table #tableDtmfList dataKey="ObjId" [value]="mtmaKeypads" [lazy]="true" (onLazyLoad)="loadKeypads($event)"
				[paginator]="true" [totalRecords]="totalRecords" [loading]="keypadsLoading" [rows]="pageSize"
				[showCurrentPageReport]="true" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true"
				responsiveLayout="stack" sortField="Code" [sortOrder]="1">
				<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
					<tr>
						<th>
							<div pSortableColumn="Code" class="flex align-items-center justify-content-center">{{ 'CODE' |
								translate }}
								<p-sortIcon field="Code"></p-sortIcon>
							</div>
						</th>
						<th>
							<div pSortableColumn="Description" class="flex align-items-center justify-content-center">{{
								'DESCRIPTION' |
								translate }}
								<p-sortIcon field="Description"></p-sortIcon>
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'ACTION' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'NAME' | translate }} {{ 'GROUP' |
								translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'ENTER_DATE_RANGE' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center"></div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-keypad>
					<tr>
						<td>
							<span class="p-column-title font-semibold">{{ 'CODE' | translate }}</span>
							<div class="flex align-items-center justify-content-center" [style]="getStyleKeypad(keypad)"
								[pTooltip]="getTooltipKeypad(keypad)">{{
								keypad.Code }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'DESCRIPTION' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ keypad.Description }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'ACTION' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ getTextAction(keypad) }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'NAME' | translate }} {{ 'GROUP' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ getRuleInfo(keypad) }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'ENTER_DATE_RANGE' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ getRuleDates(keypad) }}</div>
						</td>
						<td>
							<span class="p-column-title"></span>
							<div class="flex flex-row justify-content-center align-items-center gap-1">
								<p-button pTooltip="{{ 'EDIT' | translate}}" id="buttonMTMKBEdit-{{keypad.Name}}"
									[disabled]="isActiveTask" tooltipPosition="bottom" icon="pi cm-pencil" size="large"
									(click)="editKeypad(keypad)" [rounded]="false" [text]="true" severity="secondary">
								</p-button>
								<p-button pTooltip="{{ 'DELETE' | translate}}" id="buttonMTMKBDelete-{{keypad.Name}}"
									[disabled]="isActiveTask" tooltipPosition="bottom" icon="pi cm-trash" size="large"
									(click)="delete(keypad)" [rounded]="false" [text]="true" severity="danger">
								</p-button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>